import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

import { Model } from '../model/model';
import { ProductLine } from '../model/product-line';
import { AuthenticatedHttpService } from './authenticatedhttp.service';


@Injectable()
export class ModelService {
    private baseUrl;
    navigateBackToProductLine$: BehaviorSubject<boolean> = new BehaviorSubject(false);

    constructor(
        private _http: AuthenticatedHttpService
    ) {
        this.baseUrl = _http.getBaseURLFromCookie();
    }

    setBaseOptionsForModel(quoteId: number, retailerNumber: number): Observable<any> {
        return this._http.get(`${this.baseUrl}/api/models/baseoptions/${quoteId}/${retailerNumber}`)
            .catch(this._http.handleError);
    }

    saveBAQModelExclusions(recordsToSave: Model[]): Observable<ProductLine[]> {
        return this._http.put(`${this.baseUrl}/api/models/baqexclusions`, JSON.stringify(recordsToSave))
            .map(x => {
                return x.json();
            })
            .catch(this._http.handleError);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/services/model.service.ts